/**
 * Returns haversine(angle-in-radians).
 * hav(x) == (1 - cos(x)) / 2 == sin(x / 2)^2.
 */
export const hav = (x) => {
    return Math.sin(x * 0.5) * Math.sin(x * 0.5);
};
/**
 * Returns hav() of distance from (lat1, lng1) to (lat2, lng2) on the unit sphere.
 */
export const havDistance = (radiansLat1, radiansLng1, radiansLat2, radiansLng2) => {
    return hav(radiansLat1 - radiansLat2) + hav(radiansLng1 - radiansLng2) * Math.cos(radiansLat1) * Math.cos(radiansLat2);
};
export const degreesToRadians = (degrees) => {
    return degrees * (Math.PI / 180);
};
// Given h==hav(x), returns sin(abs(x)).
export const sinFromHav = (h) => {
    return 2 * Math.sqrt(h * (1 - h));
};
// Returns hav(asin(x)).
export const havFromSin = (x) => {
    const x2 = x * x;
    return x2 / (1 + Math.sqrt(1 - x2)) * .5;
};
// Returns sin(arcHav(x) + arcHav(y)).
export const sinSumFromHav = (x, y) => {
    const a = Math.sqrt(x * (1 - x));
    const b = Math.sqrt(y * (1 - y));
    return 2 * (a + b - 2 * (a * y + b * x));
};
/**
 * Returns sin(initial bearing from (radiansLat1,radiansLng1) to (radiansLat3,radiansLng3) minus initial bearing
 * from (radiansLat1, radiansLng1) to (radiansLat2,radiansLng2)).
 */
export const sinDeltaBearing = (radiansLat1, radiansLng1, radiansLat2, radiansLng2, radiansLat3, radiansLng3) => {
    const sinLat1 = Math.sin(radiansLat1);
    const cosLat2 = Math.cos(radiansLat2);
    const cosLat3 = Math.cos(radiansLat3);
    const lat31 = radiansLat3 - radiansLat1;
    const lng31 = radiansLng3 - radiansLng1;
    const lat21 = radiansLat2 - radiansLat1;
    const lng21 = radiansLng2 - radiansLng1;
    const a = Math.sin(lng31) * cosLat3;
    const c = Math.sin(lng21) * cosLat2;
    const b = Math.sin(lat31) + 2 * sinLat1 * cosLat3 * hav(lng31);
    const d = Math.sin(lat21) + 2 * sinLat1 * cosLat2 * hav(lng21);
    const denom = (a * a + b * b) * (c * c + d * d);
    return denom <= 0 ? 1 : (a * d - b * c) / Math.sqrt(denom);
};
//# sourceMappingURL=math-helpers.js.map